import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react'

import PropTypes from 'prop-types'

import { useField } from '@unform/core'

import InputBase from './InputBase'

const Input = forwardRef(({ name, ...props }, ref) => {
  const { fieldName, defaultValue, registerField, error } = useField(name)

  const inputRef = useRef(null)

  useImperativeHandle(ref, () => inputRef?.current)

  useEffect(() => {
    registerField({
      ref: inputRef.current,
      name: fieldName,
      path: 'value',
      getValue (input) {
        return input?.value
      }
    })
  }, [registerField, fieldName, inputRef])

  return (
    // the internal props should not be overridden
    <InputBase
      {...props}
      ref={inputRef}
      name={name}
      error={error}
      defaultValue={defaultValue}
    />
  )
})

Input.displayName = 'Input'

Input.propTypes = {
  name: PropTypes.string.isRequired
}

export default Input
